import { useEffect } from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const useLoginViewed = (params = {}) => {
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView({
      event: EVENTS.LOGIN_VIEWED,
      params,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
